<template lang="html">
  <el-dialog
    title="查看回单"
    v-if="dialogVisible"
    :visible="dialogVisible"
    @close="close"
    width="70%"
    append-to-body
    class="receipt-dialog"
  >
    <div class="receipt-box" v-loading="loading">
      <!-- 图片展示区块 -->
      <template v-if="!loading">
        <ul
          class="el-upload-list el-upload-list--picture-card img-wrapper"
          v-if="receiptUrlArr.length"
        >
          <span v-for="(item, index) in receiptUrlArr" :key="index">
              <li
                class="el-upload-list__item is-ready"
                v-for="(receipt,j) in item.receiptPhoto" :key="j"
              >
                <div class="img-div">
                  <div>车号: {{ item.plateNo }}</div>
                  <img :src="receipt" class="el-upload-list__item-thumbnail" />
                  <span class="el-upload-list__item-actions">
                    <span
                      class="el-upload-list__item-preview"
                      @click="showPreview(index,j)"
                    >
                      <i class="el-icon-zoom-in"></i>
                    </span>
                  </span>
                </div>
              </li>
            </span>
        </ul>
        <!-- 无数据展示区块 -->
        <div class="fc empty-wrapper" v-else>
          暂无数据
        </div>
      </template>
    </div>
    <!-- 大图预览 -->
    <image-viewer
            ref="imageViewer"
            v-if="showViewer"
            class="img-viewer-wrapper"
            :z-index="2000"
            :on-close="() => (showViewer = false)"
            :url-list="receiptImgArr"
    />
    <span slot="footer" class="dialog-footer"> </span>
  </el-dialog>
</template>

<script>
import qs from "qs";
import ImageViewer from "element-ui/packages/image/src/image-viewer";

export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    orderNo: {
      type: String,
      default: ""
    },
    isOld: {
      type: Boolean,
      default: false
    },
    receiptArr: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loading: false,
      receiptUrlArr: [],
      receiptImgArr: [],
      showViewer: false
    };
  },
  computed: {},
  created() {},
  methods: {
    async getData() {
      try {
        this.loading = true;
        let {
          data: {
            list
          }
        } = await this.$http.get(`/shipper/order-shipper/look-receipt`, {
          params: {
            orderNo: this.orderNo
          }
        });
        if (!list) return;
        this.receiptUrlArr = list;
      } catch (e) {
      } finally {
        this.loading = false;
      }
    },
    close() {
      this.$emit("update:dialogVisible", false);
    },
    initData() {
      this.receiptUrlArr = [];
      if (this.isOld) {
        this.receiptUrlArr = this.receiptArr;
      } else {
        this.getData();
      }
    },
    async showPreview(index,j) {
      this.receiptImgArr = this.receiptUrlArr[index]['receiptPhoto']
      this.showViewer = true;
      await this.$nextTick();
      this.$refs.imageViewer.index = j;
    }
  },
  watch: {
    dialogVisible(newVal) {
      newVal && this.initData();
    }
  },
  components: {
    ImageViewer
  }
};
</script>

<style lang="scss" scoped>
.receipt-dialog {
  .receipt-box {
    min-height: 159px;
    .img-wrapper {
      .img-div {
        width: 100%;
        height: 100%;
        .el-upload-list__item-thumbnail {
          object-fit: cover;
        }
        .el-upload-list__item-preview {
          i {
            color: #fff;
          }
        }
      }
    }
    .empty-wrapper {
      height: 159px;
    }
  }
}
</style>

<style lang="scss">
.receipt-dialog {
  .img-viewer-wrapper {
    .el-icon-circle-close {
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personal/order/detail/components/receiptDialog/index.vue